import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import Nav from "@/components/marketing/Nav";
import Footer from "@/components/marketing/Footer";
import { Reveal } from "@/components/Reveal";

const APP_IMG = "https://images.unsplash.com/photo-1657358846130-3305fd8fcd30?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function ForApplicants() {
  return (
    <div className="min-h-screen bg-softcream">
      <Nav />
      <section className="mx-auto grid max-w-page items-center gap-12 px-5 py-16 sm:px-8 sm:py-20 md:py-28 lg:grid-cols-2 lg:px-12">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-coral sm:text-base">For applicants</p>
          <h1 className="font-serif text-4xl leading-tight tracking-tight text-heading sm:text-5xl md:text-6xl">Know what you need. Every step of the way.</h1>
          <p className="mt-5 text-base leading-relaxed text-muted sm:text-lg">Holavisto is mobile-first, so you can prepare from your phone. You will always understand what is required, what is complete, what needs attention and what to do next.</p>
          <ul className="mt-6 space-y-3">
            {["A clear requirements checklist for your exact route", "Upload documents from your phone or computer", "Consistency checks across your names, dates and finances", "Plain-language findings that stay calm", "Request a human review before you submit", "An organized dossier for the official step"].map((x) => (
              <li key={x} className="flex items-start gap-2.5 text-navy"><CheckCircle2 className="mt-0.5 shrink-0 text-tblue" size={18} /> <span className="text-[15px]">{x}</span></li>
            ))}
          </ul>
          <Link to="/register" className="mt-8 inline-flex items-center gap-2 rounded bg-brandyellow px-7 py-3.5 text-sm font-semibold text-heading transition-all duration-300 " data-testid="applicants-start-btn">
            Start your application <ArrowRight size={16} />
          </Link>
        </Reveal>
        <Reveal delay={0.15} className="relative">
          <div className="absolute -right-4 -top-4 hidden h-56 w-56 rounded-md bg-cream lg:block" aria-hidden />
          <img src={APP_IMG} alt="Traveler holding a passport at the airport" className="relative w-full rounded-md border border-hborder object-cover " />
        </Reveal>
      </section>
      <Footer />
    </div>
  );
}
